import React, { useRef } from "react";
import closeIcon from "../../../../assets/close.png";
import { useClickOutside } from "../../../../hooks/useClickOutside";
import CustomButton from "../../../../common/CustomButton";
import "./PasswordModal.scss";

export const PasswordConfirmationBox = ({
  onChange,
  togglePasswordConfirmation,
  impersonateSelectedUser,
  error,
  isImpersonating,
}) => {
  const ref = useRef(null);
  useClickOutside(ref, () => togglePasswordConfirmation(false));

  return (
    <div className="password-modal" ref={ref}>
      <div className="password-confirm">
        <div className="header">
          <h2>Confirm password</h2>
          <img src={closeIcon} alt="logo" className="close" onClick={() => togglePasswordConfirmation(false)} />
        </div>
        <p>
          Please verify your identity by entering your Cognito <strong>(old login credentials)</strong> password again.
        </p>
        <div className="password-box" style={{ marginBottom: "20px" }}>
          <input
            className="new-input"
            type="password"
            onChange={(e) => onChange(e.target.value)}
            placeholder="Password"
          ></input>
        </div>

        <CustomButton onClick={() => impersonateSelectedUser()} loading={isImpersonating} variant="default" fullWidth>
          Proceed
        </CustomButton>

        {error && (
          <span style={{ color: "var(--color-error)", display: "block", marginTop: "10px" }}>
            Something went wrong impersonating
          </span>
        )}
      </div>
    </div>
  );
};
